(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
// ============================================================================
// OhrCart — shared cart controller (drawer + cart page). Single source of truth:
// every mutation goes through the Cart AJAX API with the Section Rendering API, then
// re-renders the drawer, the cart page (if present) and the nav count together.
// ============================================================================
(function () {
  if (window.OhrCart) return; // guard against double-inclusion

  // iOS Safari only fires :active on tap when a touch listener exists — this no-op
  // guarantees the stepper/remove press feedback shows on mobile.
  document.addEventListener('touchstart', function () {}, { passive: true });

  function byId(id) { return document.getElementById(id); }

  // The cart page is a JSON-template section, so its id is composite
  // (template--123__main-cart) and must be read from the DOM — the bare key
  // "main-cart" renders empty via the Section Rendering API.
  function cartPageSectionId() {
    var host = document.querySelector('[id^="shopify-section-"][id$="__main-cart"]') || byId('shopify-section-main-cart');
    return host ? host.id.replace('shopify-section-', '') : null;
  }
  // Which sections to ask the API to re-render: the drawer (always) + the cart page
  // (only when it's on the current page).
  function sectionsToRequest() {
    var ids = ['cart-drawer'];
    var cp = cartPageSectionId();
    if (cp) ids.push(cp);
    return ids;
  }

  // Find a section's DOM wrapper. Statically-rendered sections get a simple id
  // (shopify-section-NAME); JSON-template sections get a composite id
  // (shopify-section-template--123__main-cart), so fall back to a suffix match.
  function sectionHost(id) {
    return document.getElementById('shopify-section-' + id)
        || document.querySelector('[id^="shopify-section-"][id$="__' + id + '"]');
  }

  // Swap a section's rendered HTML in place, preserving the drawer's open state.
  function renderSection(id, html) {
    var host = sectionHost(id);
    if (!host || html == null) return;
    var wasOpen = false;
    var drawer = host.querySelector('#cart-drawer');
    if (drawer && drawer.classList.contains('open')) wasOpen = true;
    host.innerHTML = html;
    if (wasOpen) {
      var d = host.querySelector('#cart-drawer');
      // Fresh markup carries `inert` (closed default); clear it since we're re-opening.
      if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); d.removeAttribute('inert'); }
    }
  }

  // Dim the amounts while a request is in flight (feedback for the round-trip).
  function setBusy(on) {
    document.querySelectorAll('#cart-drawer, .cartpage').forEach(function (el) { el.classList.toggle('cart-busy', on); });
  }

  // Brief on-brand notification (stock limits etc.).
  var toastTimer;
  function showToast(msg) {
    var t = document.getElementById('cart-toast');
    if (!t || !msg) return;
    // Reveal the aria-live region FIRST, then write the text on the next frame: a
    // polite live region only announces mutations that happen while it is in the
    // accessibility tree, so setting textContent while still hidden (display:none)
    // was silent for screen readers. The empty first frame is invisible.
    t.hidden = false;
    requestAnimationFrame(function () { t.textContent = msg; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; t.textContent = ''; }, 3500);
  }
  function stockMsg(max) { return max > 0 ? ('Only ' + max + ' in stock') : 'Out of stock'; }

  // Re-snap the grid after a swap: content (and thumbnails) settle across a few frames,
  // so snap now, next frame, after images load, and once more after a short delay.
  function resnap() {
    if (!window.gridSnap) return;
    window.gridSnap();
    requestAnimationFrame(function () { window.gridSnap(); });
    document.querySelectorAll('#cart-drawer img, .cartpage img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { window.gridSnap(); }, { once: true });
    });
    setTimeout(function () { window.gridSnap(); }, 220);
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      if (sections[key] != null) renderSection(key, sections[key]);
    });
    if (window.refreshCartCount) window.refreshCartCount();
    setBusy(false);
    restorePendingQty(); // keep the number the user is actively stepping (see below)
    resnap();
  }

  // After a server re-render, re-apply any quantity the user is still stepping. The
  // Section Rendering response reflects the cart AT REQUEST TIME, so a slower earlier
  // response could otherwise overwrite the input with a stale number while newer clicks
  // are still pending — the "jumping" you see when clicking fast. The optimistic value
  // stays authoritative until its own debounced request settles (pending is cleared then).
  function restorePendingQty() {
    Object.keys(pending).forEach(function (k) {
      var row = document.querySelector('.dcart-item[data-key="' + k + '"], .cart-item[data-key="' + k + '"]');
      var input = row && row.querySelector('.dcart-qty, .step-val');
      if (input) input.value = pending[k].qty < 1 ? '' : pending[k].qty;
    });
  }

  // POST helper. Adds the sections we want re-rendered. Resolves with parsed JSON;
  // rejects (with the parsed error body) on a non-2xx (e.g. 422 over-quantity).
  function post(url, body) {
    setBusy(true);
    body.sections = sectionsToRequest();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error('cart'); e.data = data; throw e; }
        return data;
      });
    });
  }

  // Serialize cart mutations: each runs strictly after the previous one fully settles
  // (request AND its section re-render). Without this, two overlapping steppers/removes
  // could have their responses arrive out of order — the later re-render showing a stale
  // quantity, or the server ending on the wrong absolute qty. Chaining guarantees order.
  var opChain = Promise.resolve();
  function serialize(task) {
    var run = opChain.then(task, task);   // run regardless of the prior task's outcome
    opChain = run.catch(function () {});  // a failed mutation must not break the chain
    return run;
  }

  window.OhrCart = {
    // Change a line's quantity (0 removes). `key` is the line item's stable key
    // (line.key). Posting `id: key` — not a positional `line:` index — is race-safe:
    // two rapid mutations can't target the wrong row after the cart re-orders.
    change: function (key, quantity) {
      return serialize(function () {
        return post('/cart/change.js', { id: key, quantity: quantity })
          .then(function (data) { applySections(data.sections); return data; })
          .catch(function (err) {
            // Over-stock (422): re-sync the UI to the real cart, then surface Shopify's message.
            setBusy(false);
            var msg = err && err.data && (err.data.description || err.data.message);
            var done = (window.OhrCart && window.OhrCart.refresh()) || Promise.resolve();
            return done.then(function () { if (msg) showToast(msg); });
          });
      });
    },
    // Add a variant. Resolves with the cart JSON (incl. re-rendered sections).
    add: function (id, quantity) {
      return serialize(function () {
        return post('/cart/add.js', { items: [{ id: id, quantity: quantity || 1 }] })
          .then(function (data) {
            if (data.sections) applySections(data.sections);
            else if (window.OhrCart) window.OhrCart.refresh();
            return data;
          })
          .catch(function (err) {
            // A failed add (e.g. 422 over-stock) must clear the in-flight dim, else the
            // cart/drawer amounts stay at 35% opacity until the next successful mutation.
            setBusy(false);
            throw err;   // re-throw so the PDP handler still surfaces Shopify's message
          });
      });
    },
    // Re-fetch the sections for the current page and re-render (no mutation).
    refresh: function () {
      var url = window.location.pathname + '?sections=' + sectionsToRequest().join(',');
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sections) { applySections(sections); return sections; })
        .catch(function () {});
    }
  };

  // ---- Delegated controls: steppers + remove, for BOTH drawer and cart page ----
  // The line's STABLE key (line.key), read from the row — never the positional index.
  function keyFromEl(el) {
    var row = el.closest('.dcart-item, .cart-item');
    var k = row ? row.getAttribute('data-key') : null;
    return k || null;
  }
  function qtyInputFor(el) {
    var row = el.closest('.dcart-item, .cart-item');
    return row ? row.querySelector('.dcart-qty, .step-val') : null;
  }

  // Debounced, optimistic quantity change: reflect the new number instantly, coalesce
  // rapid clicks into one request, and let the server response reconcile. This makes the
  // steppers feel immediate even though each mutation is a network round-trip.
  var pending = {};
  function scheduleChange(key, qty, input) {
    if (input) input.value = qty < 1 ? '' : qty;   // optimistic
    setBusy(true);
    if (pending[key]) clearTimeout(pending[key].t);
    pending[key] = { qty: qty, t: setTimeout(function () {
      var q = pending[key] ? pending[key].qty : qty;
      delete pending[key];
      window.OhrCart.change(key, q);
    }, 350) };   // wait a touch longer so a burst of clicks coalesces into ONE request
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('.dcart-step, .step-btn');
    if (step) {
      var key = keyFromEl(step);
      var input = qtyInputFor(step);
      if (key == null || !input) return;
      var dir = parseInt(step.getAttribute('data-step'), 10) || 0;
      var max = parseInt(input.getAttribute('data-max'), 10);
      var next = (parseInt(input.value, 10) || 1) + dir;
      // Trying to step past the stock limit → tell the customer why, instantly (no round-trip).
      if (dir > 0 && !isNaN(max) && next > max) { showToast(stockMsg(max)); return; }
      if (next < 1) next = 0; // 0 → remove
      scheduleChange(key, next, input);
      return;
    }
    var remove = e.target.closest('.dcart-remove, .ci-remove');
    if (remove) {
      var rkey = keyFromEl(remove);
      if (rkey == null) return;
      var row = remove.closest('.dcart-item, .cart-item');
      if (row) row.classList.add('is-removing');   // optimistic fade
      window.OhrCart.change(rkey, 0);
    }
  });

  // Typing a quantity directly (Enter or blur) re-validates through the server.
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.dcart-qty, .step-val');
    if (!input) return;
    var key = keyFromEl(input);
    if (key == null) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) v = 1;
    var max = parseInt(input.getAttribute('data-max'), 10);
    if (!isNaN(max) && v > max) v = max;
    scheduleChange(key, v, input);
  });

  // First cart-page paint: re-snap once fonts + thumbnails settle (fixes the first
  // divider landing off-grid before content settles).
  if (document.querySelector('.cartpage')) {
    window.addEventListener('load', resnap);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(resnap);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
(function () {
  var form = document.getElementById('contact-form');
  if (!form) return;
  var btn = document.getElementById('contact-send');
  var okBox = document.getElementById('contact-success');
  var errBox = document.getElementById('contact-error');
  var endpoint = form.dataset.endpoint || '';
  var token = form.dataset.token || '';
  var sendLabel = btn ? btn.innerHTML : 'Send';

  function val(n) { var el = form.elements[n]; return el ? el.value.trim() : ''; }
  function mark(n, bad) { var el = form.elements[n]; if (el) el.classList.toggle('invalid', !!bad); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = val('name'), email = val('email'), subject = val('subject'), comment = val('comment');
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    mark('name', !name);
    mark('email', !email || !emailOk);
    mark('subject', !subject);
    if (!name || !email || !emailOk || !subject) {
      var first = !name ? 'name' : (!email || !emailOk) ? 'email' : 'subject';
      if (form.elements[first]) form.elements[first].focus();
      return;
    }
    if (okBox) okBox.hidden = true;
    if (errBox) errBox.hidden = true;
    if (!endpoint || !token) { if (errBox) errBox.hidden = false; return; }

    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
      body: JSON.stringify({ name: name, email: email, subject: subject, comment: comment })
    })
      .then(function (res) {
        if (res.status === 201 || res.ok) {
          if (okBox) { okBox.hidden = false; okBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          form.reset();
        } else if (errBox) {
          errBox.hidden = false;
        }
      })
      .catch(function () { if (errBox) errBox.hidden = false; })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = sendLabel; } });
  });

  window.addEventListener('pageshow', function () { if (btn) btn.disabled = false; });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
/* ----- FAQ accordion ----- */
/* Instant, mechanical toggle (matches the grid aesthetic) then re-run the global
   locator so every item's top + height re-snaps to the grid and the dividers land
   back on grid lines. No height animation — fractional mid-tween heights would fight
   the snap. */
(function () {
  var items = document.querySelectorAll('.faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (window.gridSnap) window.gridSnap();
      if (window.drawGrid) window.drawGrid();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
// ----- Nav cart indicator (count + green dot) — updated site-wide after add/change -----
window.updateCartCount = function (count) {
  document.querySelectorAll('.cart, .nav-cart-btn').forEach(function (el) {
    el.classList.toggle('cart--filled', count > 0);
    var c = el.querySelector('.cart-count, .count');
    if (c) c.textContent = count;
  });
};
// Re-read the real cart and refresh the indicator (source of truth = Shopify).
window.refreshCartCount = function () {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { window.updateCartCount(c.item_count); return c; })
    .catch(function () { /* offline / preview — leave server-rendered count */ });
};

// ----- Mobile drawers (menu + cart) -----
// The cart drawer is re-rendered by the Section Rendering API, so we query it FRESH
// each time and close via delegation (never cache the element or its close button).
(function () {
  var scrim = document.getElementById('drawer-scrim');
  var menuDrawer = document.getElementById('menu-drawer');
  function cartDrawer() { return document.getElementById('cart-drawer'); }
  function openDrawer(d) {
    if (!d) return;
    // `inert` keeps a CLOSED drawer's controls (incl. the Checkout button) out of the
    // keyboard tab order and the a11y tree — they sit off-screen via transform only, so
    // without this they were silently tabbable on every page. Cleared on the open drawer.
    [menuDrawer, cartDrawer()].forEach(function (x) { if (x) { x.classList.remove('open'); x.setAttribute('aria-hidden', 'true'); x.setAttribute('inert', ''); } });
    // snap BEFORE the drawer becomes visible so it's already grid-aligned on frame 1
    d.style.visibility = 'hidden';
    d.classList.add('open');
    if (window.gridSnap) window.gridSnap();   // synchronous — measured while hidden, no visible jump
    d.style.visibility = '';
    d.setAttribute('aria-hidden', 'false');
    d.removeAttribute('inert');
    scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    // scrollbar is now gone → viewport width changed with no resize event; recompute --cell
    requestAnimationFrame(function () { if (window.fitCell) window.fitCell(); if (window.drawGrid) window.drawGrid(); if (window.gridSnap) window.gridSnap(); });
  }
  function closeDrawers() {
    [menuDrawer, cartDrawer()].forEach(function (x) { if (x) { x.classList.remove('open'); x.setAttribute('aria-hidden', 'true'); x.setAttribute('inert', ''); } });
    scrim.classList.remove('open');
    document.body.style.overflow = '';
    requestAnimationFrame(function () { if (window.fitCell) window.fitCell(); if (window.drawGrid) window.drawGrid(); if (window.gridSnap) window.gridSnap(); });
  }
  window.openCartDrawer = function () { openDrawer(cartDrawer()); };
  window.closeDrawers = closeDrawers;

  var bind = function (id, fn) { var el = document.getElementById(id); if (el) el.addEventListener('click', function (e) { e.preventDefault(); fn(); }); };
  bind('menu-open', function () { openDrawer(menuDrawer); });
  bind('cart-open', window.openCartDrawer);           // mobile cart button → slide the drawer open
  // Close buttons live inside re-rendered drawers → delegate.
  document.addEventListener('click', function (e) { if (e.target.closest('.drawer-close')) { e.preventDefault(); closeDrawers(); } });
  if (scrim) scrim.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });
  if (menuDrawer) menuDrawer.querySelectorAll('.drawer-links a').forEach(function (a) { a.addEventListener('click', closeDrawers); });

  // Localization selectors (region/currency, header + footer) auto-submit on change.
  // A country change reloads the page (new prices/currency); the menu closing with it
  // is fine.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-localization]');
    if (sel && sel.form) sel.form.submit();
  });

  var _drawerT;
  window.addEventListener('resize', function () {
    clearTimeout(_drawerT);
    _drawerT = setTimeout(function () { if (window.gridSnap) window.gridSnap(); }, 120);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing"] && !Shopify.designMode) return;
  try {
    
// ----- Hero spin: intro plays once, then hands off to the loop -----
// The intro's last frame is the loop's first pose, so swapping the two elements
// on 'ended' is seamless. The loop starts downloading once the intro is playing
// so it doesn't compete with the intro for bandwidth.
(function () {
  const intro = document.querySelector('[data-spin-intro]');
  const loop = document.querySelector('[data-spin-loop]');
  if (!intro || !loop) return;

  const preloadLoop = () => {
    if (loop.preload === 'auto') return;
    loop.preload = 'auto';
    loop.load();
  };
  // This bundle is deferred, so the intro may already be playing by now
  if (!intro.paused) preloadLoop();
  else intro.addEventListener('playing', preloadLoop, { once: true });

  const handoff = () => {
    loop.play().then(() => {
      loop.hidden = false;
      intro.hidden = true;
    }).catch(() => {}); // refused: resume() retries
  };
  intro.addEventListener('ended', handoff);

  // Chrome on iOS can refuse the `autoplay` attribute / an early play() (e.g. before
  // the video has data or has been laid out) without trying again, and iOS pauses
  // video when the page is hidden (tab/app switch, back-forward cache). So keep
  // retrying while the current clip is paused: when it has data, scrolls into view,
  // the page is shown again, a few times over the first seconds, and on the first
  // tap (which also unlocks Low Power Mode).
  const resume = () => {
    if (loop.hidden && intro.ended) return handoff();
    const active = loop.hidden ? intro : loop;
    if (active.paused) active.play().catch(() => {});
  };
  ['loadeddata', 'canplay', 'canplaythrough'].forEach((ev) => intro.addEventListener(ev, resume));
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) resume();
    }).observe(intro.parentElement);
  }
  // A play() fired the instant the page returns is often refused too, so retry over
  // a few seconds whenever the page (re)appears.
  const kick = () => { resume(); [300, 1000, 2500, 5000].forEach((ms) => setTimeout(resume, ms)); };
  kick();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) kick(); });
  window.addEventListener('pageshow', kick);
  window.addEventListener('focus', kick);
  // iOS can also pause it on its own while the page is visible (e.g. after a system
  // overlay); anything but the intro ending is unexpected, so restart it.
  [intro, loop].forEach((v) => v.addEventListener('pause', () => {
    if (!v.ended && !document.hidden) setTimeout(resume, 300);
  }));
  document.addEventListener('touchend', resume, { passive: true });
  document.addEventListener('click', resume);
})();

// ----- Testimonials carousel dots -----
(function () {
  const quotes = document.querySelector('.quotes');
  const dotsWrap = document.getElementById('quote-dots');
  if (!quotes || !dotsWrap) return;
  const cards = [...quotes.querySelectorAll('.quote')];
  cards.forEach((card, i) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Go to quote ' + (i + 1));
    b.addEventListener('click', () => {
      quotes.scrollTo({ left: card.offsetLeft - quotes.offsetLeft, behavior: 'smooth' });
    });
    dotsWrap.appendChild(b);
  });
  const dots = [...dotsWrap.children];
  function sync() {
    // Cards snap to the START (scroll-snap-align:start), so pick the card whose
    // left edge is nearest the scroll position — centre-based picked the 2nd card at scroll 0.
    const pos = quotes.scrollLeft + 16; // scroll-padding-left
    let active = 0, best = Infinity;
    cards.forEach((card, i) => {
      const left = card.offsetLeft - quotes.offsetLeft;
      const d = Math.abs(left - pos);
      if (d < best) { best = d; active = i; }
    });
    dots.forEach((dot, i) => dot.classList.toggle('active', i === active));
  }
  let raf;
  quotes.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); });
  // Always start on the FIRST card. Layout shifts (fonts / grid re-fit) after first
  // paint can leave the scroller mid-way (landing on card 2); pin it to 0 once things settle.
  function resetStart() { quotes.scrollLeft = 0; sync(); }
  resetStart();
  window.addEventListener('load', () => { resetStart(); setTimeout(resetStart, 300); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(resetStart);
})();

(function () {
  // Seven-segment geometry
  var SEGMAP = {
    '0':['a','b','c','d','e','f'], '1':['b','c'], '2':['a','b','g','e','d'],
    '3':['a','b','g','c','d'], '4':['f','g','b','c'], '5':['a','f','g','c','d'],
    '6':['a','f','g','e','c','d'], '7':['a','b','c'],
    '8':['a','b','c','d','e','f','g'], '9':['a','b','c','d','f','g']
  };
  var W = 70, H = 70, T = 14, GP = 6;        // seg length, half-height, thickness, end gap
  var Y0 = 193, X0S = [131, 245, 359];        // digit origins inside display window
  var OFF_DEFAULT = '#d9d9d9';
  var STATES = [
    { s: '065', c: '#00c800' },
    { s: '080', c: '#e8a800' },
    { s: '083', c: '#ff7a1a' },
    { s: '085', c: '#ff2626' }
  ];
  var NS = 'http://www.w3.org/2000/svg';

  function hSeg(x, y, len) {
    var t = T / 2;
    return [ [x, y], [x + t, y - t], [x + len - t, y - t], [x + len, y], [x + len - t, y + t], [x + t, y + t] ]
      .map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' ');
  }
  function vSeg(x, y, len) {
    var t = T / 2;
    return [ [x, y], [x + t, y + t], [x + t, y + len - t], [x, y + len], [x - t, y + len - t], [x - t, y + t] ]
      .map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' ');
  }
  function segPoints(seg, x0, y0) {
    switch (seg) {
      case 'a': return hSeg(x0 + GP, y0, W - 2 * GP);
      case 'g': return hSeg(x0 + GP, y0 + H, W - 2 * GP);
      case 'd': return hSeg(x0 + GP, y0 + 2 * H, W - 2 * GP);
      case 'f': return vSeg(x0, y0 + GP, H - 2 * GP);
      case 'b': return vSeg(x0 + W, y0 + GP, H - 2 * GP);
      case 'e': return vSeg(x0, y0 + H + GP, H - 2 * GP);
      case 'c': return vSeg(x0 + W, y0 + H + GP, H - 2 * GP);
    }
  }

  function buildDisplay(svg) {
    var OFF = svg.dataset.off || OFF_DEFAULT;
    var host = svg.querySelector('.seg-digits');
    var digits = [];
    var order = ['a','b','c','d','e','f','g'];
    for (var i = 0; i < 3; i++) {
      var map = {};
      order.forEach(function (seg) {
        var poly = document.createElementNS(NS, 'polygon');
        poly.setAttribute('points', segPoints(seg, X0S[i], Y0));
        poly.setAttribute('class', 'seg');
        poly.setAttribute('fill', OFF);
        host.appendChild(poly);
        map[seg] = poly;
      });
      digits.push(map);
    }
    // trailing decimal point (as in the display)
    var dot = document.createElementNS(NS, 'circle');
    dot.setAttribute('cx', X0S[2] + W + 20);
    dot.setAttribute('cy', Y0 + 2 * H);
    dot.setAttribute('r', T / 2 + 1);
    dot.setAttribute('class', 'seg dot');
    dot.setAttribute('fill', OFF);
    host.appendChild(dot);
    return { digits: digits, dot: dot, off: OFF };
  }

  function render(disp, state) {
    var chars = state.s.split('');
    disp.digits.forEach(function (map, i) {
      var on = SEGMAP[chars[i]] || [];
      Object.keys(map).forEach(function (seg) {
        var lit = on.indexOf(seg) !== -1;
        map[seg].setAttribute('fill', lit ? state.c : disp.off);
        map[seg].style.filter = lit ? 'drop-shadow(0 0 3px ' + state.c + ')' : 'none';
      });
    });
    disp.dot.setAttribute('fill', state.c);
    disp.dot.style.filter = 'drop-shadow(0 0 3px ' + state.c + ')';
  }

  // Animations play for everyone (owner's choice) — no reduced-motion gate.
  document.querySelectorAll('svg.seg-display').forEach(function (svg) {
    var disp = buildDisplay(svg);
    var idx = 0;
    render(disp, STATES[0]);
    setInterval(function () {
      idx = (idx + 1) % STATES.length;
      render(disp, STATES[idx]);
    }, 1100);
  });
})();

// ----- Newsletter signup (Shopify customer form) -----
// Submits NATIVELY so Shopify's built-in spam protection runs invisibly (an
// AJAX submit fights it and pops a visible captcha). Shopify creates the
// customer and redirects back with ?customer_posted=true; we catch that on
// load to show the inline confirmation and scroll the signup into view.
(function () {
  if (window.location.search.indexOf('customer_posted=true') === -1) return;
  var section = document.querySelector('.signup');
  var status = section && section.querySelector('.signup-status');
  if (status) {
    status.textContent = "You're on the list — welcome to the crew.";
    status.setAttribute('data-state', 'success');
  }
  if (section) { try { section.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manual"]) return;
  try {
    
/* ----- Manual masthead: typewriter "Hi, I'm Ohr-1." ----- */
(function () {
  var mast = document.querySelector('.manual-mast');
  if (!mast) return;
  var textEl = mast.querySelector('.greet-text');
  var full = textEl.textContent;
  var len = full.length;
  var step = 0.09; // seconds per character
  function run() {
    var natural = textEl.scrollWidth;
    mast.style.setProperty('--len', len);
    mast.style.setProperty('--type-w', natural + 'px');
    mast.style.setProperty('--type-dur', (len * step).toFixed(2) + 's');
    requestAnimationFrame(function () { requestAnimationFrame(function () { mast.classList.add('play'); }); });
  }
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(run); } else { run(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
// MOBILE: the price-row Judge.me badge shows just the count number ("199"), not
// "199 reviews". Class-agnostic: walk the badge's text nodes and strip the label
// wherever it appears; re-apply via MutationObserver because Judge.me's script can
// re-hydrate the badge after load (rewrite → observer refires → no match → stable).
(function () {
  if (window.innerWidth >= 990) return;
  var host = document.querySelector('.buy-reviews');
  if (!host) return;
  function strip() {
    var w = document.createTreeWalker(host, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) {
      if (/\d\s*reviews?/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/(\d+)\s*reviews?\s*/i, '$1');
    }
  }
  strip();
  if (window.MutationObserver) {
    new MutationObserver(strip).observe(host, { childList: true, subtree: true, characterData: true });
  }
})();

// ----- Gallery preloader: after the page settles, quietly fetch every full-size
// image (both colours) one at a time so variant/thumb switches hit the browser
// cache and swap instantly instead of paying a CDN fetch + decode per click. -----
(function () {
  window.addEventListener('load', function () {
    var urls = [];
    document.querySelectorAll('.thumb[data-full]').forEach(function (t) {
      var u = t.getAttribute('data-full');
      if (u && urls.indexOf(u) === -1) urls.push(u);
    });
    var i = 0;
    function next() {
      if (i >= urls.length) return;
      var im = new Image();
      im.onload = im.onerror = function () { setTimeout(next, 60); };
      im.src = urls[i++];
    }
    setTimeout(next, 800); // let the visible page finish first
  });
})();

(function () {
  // ----- Gallery (rendered from product.media; thumbs tagged by colour) -----
  var main = document.getElementById('gal-img');
  var idxEl = document.getElementById('gal-index');
  var totalEl = document.getElementById('gal-total');
  var allThumbs = Array.prototype.slice.call(document.querySelectorAll('#gal-thumbs .thumb'));
  var visible = [];   // thumbs for the currently-selected colour
  var i = 0;
  function show(n) {
    if (!visible.length) return;
    i = (n + visible.length) % visible.length;
    var t = visible[i];
    var full = t.getAttribute('data-full');
    if (main && full) { main.src = full; main.alt = t.getAttribute('data-alt') || ''; }
    if (idxEl) idxEl.textContent = String(i + 1).padStart(2, '0');
    allThumbs.forEach(function (x) { x.classList.remove('active'); });
    t.classList.add('active');
  }
  // Show only the thumbnails whose colour matches the selected variant; if the media
  // isn't colour-tagged (single-colour product), fall back to showing everything.
  function filterByColour(colour) {
    var matches = allThumbs.filter(function (t) { return t.getAttribute('data-colour') === colour; });
    if (!matches.length) matches = allThumbs;
    allThumbs.forEach(function (t) { t.hidden = matches.indexOf(t) === -1; });
    visible = matches;
    if (totalEl) totalEl.textContent = String(visible.length).padStart(2, '0');
    show(0);
    if (window.gridSnap) window.gridSnap();
  }
  allThumbs.forEach(function (t) { t.addEventListener('click', function () { show(visible.indexOf(t)); }); });

  var galPrev = document.getElementById('gal-prev');
  var galNext = document.getElementById('gal-next');
  if (galPrev) galPrev.addEventListener('click', function () { show(i - 1); });
  if (galNext) galNext.addEventListener('click', function () { show(i + 1); });

  // Swipe left/right on the main image (mobile) to move through the gallery.
  var galMain = document.querySelector('.pdp-gallery .gallery-main');
  if (galMain) {
    var swX = 0, swY = 0, swiping = false;
    galMain.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { swiping = false; return; }
      swX = e.touches[0].clientX; swY = e.touches[0].clientY; swiping = true;
    }, { passive: true });
    galMain.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - swX, dy = t.clientY - swY;
      // Horizontal swipe past the threshold, and clearly more horizontal than vertical.
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        show(dx < 0 ? i + 1 : i - 1);
      }
    }, { passive: true });
  }

  // desktop thumbnail strip scroll arrows
  var thumbStrip = document.getElementById('gal-thumbs');
  var tPrev = document.getElementById('thumb-prev');
  var tNext = document.getElementById('thumb-next');
  function scrollThumbs(dir) {
    if (!thumbStrip) return;
    var cell = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cell')) || 40;
    thumbStrip.scrollBy({ left: dir * cell * 4, behavior: 'smooth' });
  }
  if (tPrev) tPrev.addEventListener('click', function () { scrollThumbs(-1); });
  if (tNext) tNext.addEventListener('click', function () { scrollThumbs(1); });

  document.addEventListener('keydown', function (e) {
    if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
    if (e.key === 'ArrowLeft') show(i - 1);
    else if (e.key === 'ArrowRight') show(i + 1);
  });
  // Late-loading images shift layout after paint — re-snap the grid once each settles.
  if (main) main.addEventListener('load', function () { if (window.gridSnap) window.gridSnap(); });

  // ----- Elements -----
  var q = document.getElementById('qty-val');
  var qDec = document.getElementById('qty-dec');
  var qInc = document.getElementById('qty-inc');
  var swatches = Array.prototype.slice.call(document.querySelectorAll('#swatches .swatch'));
  var colourName = document.getElementById('colour-name');
  var priceEl = document.getElementById('pdp-price');
  var variantInput = document.getElementById('pdp-variant-id');
  var addBtn = document.getElementById('add-cart');
  var addLabel = addBtn ? addBtn.querySelector('.add-label') : null;
  var errEl = document.getElementById('pdp-error');

  // ----- Inline error (stock / quantity limits) -----
  function showError(msg) { if (!errEl) return; errEl.textContent = msg; errEl.hidden = false; if (window.gridSnap) window.gridSnap(); }
  function clearError() { if (!errEl || errEl.hidden) return; errEl.textContent = ''; errEl.hidden = true; if (window.gridSnap) window.gridSnap(); }

  // ----- Quantity stepper (soft-capped at the variant's stock; server is authoritative) -----
  var qtyMax = Infinity;
  function readMax(sw) {
    if (sw && sw.getAttribute('data-inventory-managed') === '1' && sw.getAttribute('data-inventory-policy') === 'deny') {
      var n = parseInt(sw.getAttribute('data-inventory-qty'), 10);
      return n > 0 ? n : 0;
    }
    return Infinity;
  }
  function clampQty() {
    if (!q) return;
    var v = parseInt(q.value, 10) || 1;
    q.value = Math.max(1, Math.min(qtyMax, v));
  }
  if (q) {
    q.addEventListener('input', function () { q.value = q.value.replace(/[^0-9]/g, ''); });
    q.addEventListener('change', function () { clampQty(); clearError(); });
    if (qDec) qDec.addEventListener('click', function () { q.value = (parseInt(q.value, 10) || 1) - 1; clampQty(); clearError(); });
    if (qInc) qInc.addEventListener('click', function () { q.value = (parseInt(q.value, 10) || 1) + 1; clampQty(); clearError(); });
  }

  // ----- Swatches → select the real Shopify variant + swap gallery to its photos -----
  function selectSwatch(sw) {
    swatches.forEach(function (s) { s.classList.remove('active'); s.setAttribute('aria-pressed', 'false'); });
    sw.classList.add('active');
    sw.setAttribute('aria-pressed', 'true');
    var colour = sw.getAttribute('data-colour');
    if (colourName) colourName.textContent = colour;
    if (priceEl && sw.getAttribute('data-price')) priceEl.textContent = sw.getAttribute('data-price');
    if (variantInput) variantInput.value = sw.getAttribute('data-variant-id') || '';
    var available = sw.getAttribute('data-available') === '1';
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.setAttribute('aria-disabled', String(!available));
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
    }
    qtyMax = readMax(sw);
    if (q) { q.setAttribute('max', qtyMax === Infinity ? '99' : String(qtyMax)); clampQty(); }
    clearError();
    filterByColour(colour);   // sold-out variants still show their photos
  }
  swatches.forEach(function (sw) { sw.addEventListener('click', function () { selectSwatch(sw); }); });

  // Init: adopt the pre-selected variant's stock cap + colour set.
  var initActive = document.querySelector('#swatches .swatch.active');
  if (initActive) qtyMax = readMax(initActive);
  clampQty();
  filterByColour(initActive ? initActive.getAttribute('data-colour') : '');

  // ----- Add to cart (responsive) -----
  //   Desktop (>=990): add via AJAX → cart page.  Mobile (<990): add → slide the
  //   cart drawer open (Phase 5; falls back to the cart page until it's built).
  //   Over-quantity / out-of-stock: Cart API returns 422 → show its message inline.
  var CART_URL = (addBtn && addBtn.getAttribute('data-cart-url')) || '/cart';
  var form = document.getElementById('pdp-form');
  if (form && addBtn) {
    form.addEventListener('submit', function (e) {
      if (addBtn.disabled) { e.preventDefault(); return; }
      if (!window.fetch) return; // no AJAX → native POST (Shopify adds + redirects to /cart)
      e.preventDefault();
      clearError();
      var id = variantInput ? variantInput.value : '';
      var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
      if (!id) return;
      var prev = addLabel ? addLabel.textContent : '';
      if (addLabel) addLabel.textContent = 'Adding…';
      addBtn.disabled = true;
      // Prefer the shared cart controller (adds via AJAX + re-renders the drawer via the
      // Section Rendering API). Fall back to a bare add if it isn't present.
      var addPromise = (window.OhrCart && window.OhrCart.add)
        ? window.OhrCart.add(id, qty)
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok) { var e = new Error('cart'); e.data = d; throw e; } return d; }); });
      addPromise
        .then(function () {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = prev || 'Add to cart';
          if (window.refreshCartCount) window.refreshCartCount();
          if (window.innerWidth < 990 && typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();          // mobile: slide the (now re-rendered) drawer open
          } else {
            window.location.href = CART_URL;  // desktop (+ mobile fallback): cart page
          }
        })
        .catch(function (err) {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = prev || 'Add to cart';
          // 422: inventory exceeded — Shopify supplies a human message in `description`.
          var d = err && err.data;
          showError((d && (d.description || d.message)) || 'Something went wrong. Please try again.');
        });
    });
  }
})();

// Judge.me's review widget renders asynchronously (Vue), changing the reviews box
// height after the initial grid snap. Re-run the global grid snapper whenever the
// widget mutates so the box (data-g-block) and any data-g-fit elements re-align.
// childList-only observer → grid snapping (which only changes styles) can't re-trigger it.
(function () {
  var host = document.querySelector('.pdp-reviews');
  if (!host || !window.MutationObserver) return;
  var t;
  // Tag Judge.me's action group with our global fit attributes so gridSnap snaps it
  // like the theme's own buttons — this is what smashed the mobile alignment. No width
  // trims/transforms (those broke desktop); desktop is left as-is.
  function resnap() {
    clearTimeout(t);
    t = setTimeout(function () {
      var group = host.querySelector('.jm-review-widget-minimal-header__button-and-filters');
      if (group) { group.setAttribute('data-g-fit', ''); group.setAttribute('data-g-fit-x', ''); }
      if (window.gridSnap) window.gridSnap();
    }, 200);
  }
  new MutationObserver(resnap).observe(host, { childList: true, subtree: true });
  window.addEventListener('load', function () {
    setTimeout(resnap, 500);
    setTimeout(resnap, 1500);
  });
  window.addEventListener('resize', resnap);
})();

  } catch(e) { console.error(e); }
})();
})();
